import moment from 'moment'
import { preProcessSpec } from 'oderon-commons/src/tables'

const check = 'mdi-checkbox-marked-circle',
  cross = 'mdi-close-circle',
  wait = 'mdi-dots-horizontal-circle',
  green = 'green--text icon-small',
  red = 'red--text icon-small',
  yellow = 'orange--text icon-small',
  delivered = { iconText: check, iconClass: green, value: true },
  pending = { iconText: wait, iconClass: yellow, value: false },
  cancelled = { iconText: cross, iconClass: red, value: false }

const smallDate = (x) => moment(x).format('DD/MMM HH:mm')

function translateInfoAndLabel(row) {
  if (row.information == row.label) {
    return row.information
  } else {
    return `${row.information} ─ ${row.label}`
  }
}

function translateStatus(row) {
  if (row.deliveredAt != null) return delivered
  if (row.deletedAt == null) return pending
  return cancelled
}

export const fullSpec = preProcessSpec({
  defaultSortable: false,
  columns: [
    { t: 'ID|', d: 'id', w: 85, color: '#cccccc' },
    { t: 'Tipo ─ Label', code: 'information', d: translateInfoAndLabel },
    { t: 'Status|', w: 60, d: translateStatus },
    { t: 'Criado|', d: 'createdAt', w: 140, f: smallDate },
    { t: 'Entregue|', d: 'deliveredAt', w: 140, f: smallDate }
  ]
})

export const portletSpec = preProcessSpec({
  defaultSortable: false,
  columns: [
    { t: 'Tipo ─ Label', code: 'information', d: translateInfoAndLabel },
    { t: '', align: 'right', code: 'status', w: 45, d: translateStatus },
    { t: 'Criado|', d: 'createdAt', w: 120, f: smallDate },
    { t: 'Entregue|', d: 'deliveredAt', w: 120, f: smallDate }
  ]
})
